<phx-time-input
  *ngIf="phxShowInput"
  class="phx-time-picker-panel-input"
  [phxTimePickerFormat]="phxTimePickerFormat"
  [phxPanelTimePicker]="true"
  [phxDisableBefore]="phxDisableBefore"
  [phxDisableAfter]="phxDisableAfter"
  [phxSuffix]="phxInputSuffix"
  [(ngModel)]="phxValue"
  (ngModelChange)="onTimeInputChange($event)"
></phx-time-input>
<div class="phx-time phx-web-type-body-medium">
  <div class="phx-time-picker-row phx-time-picker-row-hours">
    <div
      class="phx-time-box"
      #hourBox
      *ngFor="let hour of hoursArray; let i = index"
      [class.selected]="selectedHour == hour"
      [class.phx-time-box-disabled]="isHourDisabled(hour)"
      (click)="!isHourDisabled(hour) && selectHour(hour)"
      (keydown)="handleKeydown($event, i, 'hour')"
      tabindex="0"
    >
      {{ hour }}
    </div>
  </div>
  <div class="phx-time-picker-row phx-time-picker-row-minutes">
    <div
      class="phx-time-box"
      #minuteBox
      [class.selected]="selectedMinute == minute"
      [class.phx-time-box-disabled]="isMinuteDisabled(minute)"
      *ngFor="let minute of minutesArray; let i = index"
      (click)="!isMinuteDisabled(minute) && selectMinute(minute)"
      (keydown)="handleKeydown($event, i, 'minute')"
      tabindex="0"
    >
      {{ minute }}
    </div>
  </div>
  <div class="phx-time-picker-row phx-time-picker-row-ampm" *ngIf="phxTimePickerFormat === 'default'">
    <div
      class="phx-time-box"
      #ampmBox
      [class.selected]="selectedAmPm == period"
      [class.phx-time-box-disabled]="isAmPmDisabled(period)"
      *ngFor="let period of amPmArray; let i = index"
      (click)="!isAmPmDisabled(period) && selectAmPm(period)"
      (keydown)="handleKeydown($event, i, 'ampm')"
      tabindex="0"
    >
      {{ period }}
    </div>
  </div>
</div>
